import { IApiError } from '@/models/apiError.model';
import { ISettings } from '@/models/settings.model';

export const SETTINGS_SLICE_NAME = 'settings';

export interface SettingsState {
  settings: ISettings | null;
  isLoading: boolean;
  error: IApiError | null;
}

export const initialState: SettingsState = {
  settings: null,
  isLoading: false,
  error: null,
};
